<h1 mat-dialog-title>
    {{'Upload' | translate}} {{ titleDisplayName }}
</h1>

<form [formGroup]="form">
    <div mat-dialog-content>
        <input
          type="file"
          [hidden]="true"
          #fileInput
          (change)="onFileSelected($event)"
          [accept]="accept"
          multiple
        />
        <mat-hint>{{'Accepted file extensions' | translate}} {{accept}}</mat-hint>
        <div formArrayName="files" *ngIf="filesArray?.controls?.length > 0">
          <div
            *ngFor="let fileGroup of filesArray.controls; let i = index"
            [formGroupName]="i"
            class="file-entry"
            style="margin-bottom: 2vh; border: 1px solid #ccc; padding: 1vh; border-radius: 8px;"
          >
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div style="font-weight: bold;">
                {{ 'Selected File' | translate }}: {{ fileGroup.get('fileName')?.value }}
              </div>
              <button mat-icon-button color="warn" (click)="removeFile(i)" *ngIf="!uploading">
                <mat-icon>close</mat-icon>
              </button>
            </div>
    
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 1vh;">
              <mat-label>{{ 'Title' | translate }}</mat-label>
              <input
                matInput
                formControlName="title"
                [maxlength]="titleMetadata.charlimit"
                [readonly]="uploading"
              />
            </mat-form-field>
    
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 1vh;">
              <mat-label>{{ 'Description' | translate }}</mat-label>
              <textarea
                matInput
                [value]="descriptionValue"
                formControlName="description"
                [readonly]="uploading"
                rows="3"
                [maxlength]="descriptionLimit"
              ></textarea>
            </mat-form-field>
    
            <div *ngIf="uploadMessages[i]" style="margin-top: 0.5vh; font-size: 0.9em;">
              <mat-icon *ngIf="uploadMessages[i].status" color="primary" style="vertical-align: bottom;">check_circle</mat-icon>
              <mat-icon *ngIf="!uploadMessages[i].status" color="warn" style="vertical-align: bottom;">error</mat-icon>
              {{ uploadMessages[i].message }}
            </div>
          </div>
        </div>
      </div>
  
    <div mat-dialog-actions>
      <div fxLayout="row" fxFlex fxLayoutGap="0px">
        <div fxFlex align="right">
          <button type="button" mat-raised-button (click)="fileInput.value = null;fileInput.click()">
            {{ 'Select File(s)' | translate }}
          </button>
          <button
            class="green-text"
            mat-raised-button
            (click)="uploadFiles()"
            [disabled]="filesArray.length === 0 || filesArray.invalid"
          >
            {{ 'Upload' | translate }}
          </button>
          <button type="button" class="red-text" mat-raised-button (click)="close()">
            {{ 'Cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>